<template>
  <div style="height: 534px;">
    <gj-table
        ref="gjTable"
        name="saleHotRank"
        :index="false"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="486"
        :pageSizes="[20,50,100]"
        :default-sort="{prop: 'sales_gross_profit', order: 'descending'}"
        :pagination="pagination"
        @page-change="$gjNoticeQuery"
    >
      <template v-slot:index="{row,index}">
        {{rank(row,index)}}
      </template>

      <template v-slot:salesGrossProfit="{row}">
        <span class="colorGreen">{{row.salesGrossProfit | defaultShow(row.currencySymbol)}}</span>
      </template>

      <template #empty v-if="!showStoreMask">
        <div></div>
      </template>
    </gj-table>
  </div>
</template>

<script>
import {queryMixin} from "@/minxins";
import {rankMixin} from "@/views/modules/home/components/rank/components/mixin";
import {getPerformanceRank} from "@/api/dashboard";
import {mapGetters} from "vuex";

export default {
  name: "app-dashboard-performance-rank",
  mixins: [queryMixin, rankMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  data() {
    return {
      rankName: 'performanceContribution',
      tableData: [],
      columns: [
        {id: 'index', header: '排名', field: 'slot:index', width: '60px'},
        {id: 'saleName', header: '负责人', field: 'saleName', width: '100px'},
        {id: 'orderProductSales', header: '销售额', field: 'orderProductSales',prefix: 'currencySymbol', align: 'right', minWidth: '100px'},
        {id: 'salesGrossProfit', header: '销售毛利', field: 'slot:salesGrossProfit',prefix:'currencySymbol', align: 'right', minWidth: '100px', color:'red'},
        {id: 'salesNetProfit', header: '净毛利', field: 'salesNetProfit', prefix: 'currencySymbol',align: 'right', minWidth: '100px'},
        {id: 'salesNetProfitRate', header: '净毛利率', field: 'salesNetProfitRate',suffix:'%', align: 'right', minWidth: '100px', color:'red'},
      ],
    }
  },
  methods: {
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      // 查询
      this.loading = true;
      let params = {
        model:{
          currency: this.dashboardCurrency,
          month:this.month,
          countrys: this.countryMarket.countryIds,// 国家
          marketIds: this.countryMarket.marketIds,// 店铺
        },
        ...this.queryPagination,
        ...this.querySort,
      }
      getPerformanceRank(params)
          .then((data) => {
            this.tableData = data.records || [];
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "common";
/deep/ .vxe-table--render-default .vxe-cell{
  padding-left: 10px;
}
</style>